module.exports = __webpack_public_path__ + "static/media/day06.6a747d52.jpg";